export const BRAND = {
  name: "PMPOINT",
  legalName: "PMPOINT SP. Z O.O.",
  contactPerson: "Szymon Pabisiak",
  logo: "/brand/logo/pmpoint-logo-2026.png",
  email: "kontakt@pmpoint.pl",
  phone: "571 309 237",
  phoneIntl: "48571309237",
  whatsapp: "https://wa.me/48571309237",
  address: "ul. Marcina Kasprzaka 31/119, 01-234 Warszawa",
  nip: "6312696842",
  city: "Warszawa, Polska",
};

export const IMG = {
  hero: "/brand/webp/01-hero-warsaw-apartment-desktop.webp",
  heroMobile: "/brand/webp/01-hero-warsaw-apartment-mobile.webp",
  imageModel: "/brand/webp/02-model-image-content-studio-desktop.webp",
  independent: "/brand/webp/03-model-independent-laptop-desktop.webp",
  security: "/brand/webp/05-security-contract-folder-desktop.webp",
  agencies: "/brand/webp/06-agencies-managers-desktop.webp",
  cta: "/brand/webp/07-cta-whatsapp-warsaw-desktop.webp",
  lifestyle: [
    { src: "/brand/webp/lifestyle-1-content-desktop.webp", label: "Twórz treści" },
    { src: "/brand/webp/lifestyle-2-shopping-desktop.webp", label: "Ciesz się Warszawą" },
    { src: "/brand/webp/lifestyle-3-travel-desktop.webp", label: "Podróżuj" },
    { src: "/brand/webp/lifestyle-4-car-desktop.webp", label: "Żyj lepiej" },
  ],
};

export const NAV = [
  { label: "Współpraca", href: "#wspolpraca" },
  { label: "Proces", href: "#proces" },
  { label: "Technologia", href: "#technologia" },
  { label: "Bezpieczeństwo", href: "#bezpieczenstwo" },
  { label: "FAQ", href: "#faq" },
];

export const TRUST = [
  { icon: "ShieldCheck", title: "Legalna współpraca" },
  { icon: "Lock", title: "Dyskrecja i pełna poufność" },
  { icon: "Target", title: "Indywidualna strategia" },
  { icon: "Zap", title: "Technologia i automatyzacja" },
  { icon: "TrendingUp", title: "Realne wyniki i transparentność" },
];

export const PROCESS = [
  { n: "01", icon: "MessageCircle", title: "Rozmowa", text: "Poznajemy Twoje cele i doświadczenie. Odpowiadamy na wszystkie pytania." },
  { n: "02", icon: "Target", title: "Strategia", text: "Plan działania dopasowany do Ciebie, Twojej marki i stylu pracy." },
  { n: "03", icon: "Rocket", title: "Działanie", text: "Tworzymy, wdrażamy i skalujemy kampanie oraz treści." },
  { n: "04", icon: "BarChart3", title: "Wyniki", text: "Optymalizujemy, rośniemy razem i zwiększamy Twoje przychody." },
];

export const TECH = [
  { icon: "LineChart", title: "Analityka i dane w czasie rzeczywistym" },
  { icon: "Workflow", title: "Automatyzacja marketingu" },
  { icon: "CreditCard", title: "Systemy płatności i rozliczeń" },
  { icon: "ShieldCheck", title: "Ochrona treści i prywatności" },
  { icon: "Infinity", title: "Skalowanie bez limitów" },
];

export const SECURITY = [
  "Umowa współpracy i jasne, uczciwe zasady",
  "Poufność (NDA) i ochrona danych osobowych",
  "Zgodność z prawem i regulaminami platform",
  "Pełna kontrola nad Twoją marką i treściami",
];

export const PLATFORMS = [
  "OnlyFans", "Fansly", "Fanvue", "MYM", "Tinder", "Badoo",
  "Bumble", "Telegram", "WhatsApp", "Instagram", "Facebook", "TikTok", "X",
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Udostępniam wizerunek",
    text: "Pracujesz z własnym wizerunkiem. Tworzymy strategię, treści i kampanie, które sprzedają Twoją markę.",
    img: IMG.imageModel,
    accent: "coral",
  },
  {
    n: "02",
    title: "Działam niezależnie",
    text: "Nie pokazujesz twarzy? Żaden problem. Budujemy markę i sprzedaż w modelu anonimowym i zautomatyzowanym.",
    img: IMG.independent,
    accent: "violet",
  },
];

export const FAQ = [
  {
    q: "Na czym polega współpraca z PMPOINT?",
    a: "Zajmujemy się marketingiem, strategią, prowadzeniem kampanii, czatowaniem i automatyzacją. Ty tworzysz treści, my zamieniamy uwagę w realne przychody. Rozliczamy się w modelu procentowym — zarabiamy, gdy Ty zarabiasz.",
  },
  {
    q: "Czy muszę pokazywać twarz?",
    a: "Nie. Oferujemy zarówno model z wizerunkiem, jak i w pełni anonimowy. Dobieramy strategię do Twoich preferencji i granic.",
  },
  {
    q: "Czy to jest legalne i bezpieczne?",
    a: "Tak. Działamy na podstawie umowy z jasnymi zasadami, z poufnością (NDA), ochroną danych i zgodnością z regulaminami platform. Współpracujemy wyłącznie z osobami pełnoletnimi (18+).",
  },
  {
    q: "Ile mogę zarobić?",
    a: "Wyniki zależą od profilu, zaangażowania i zakresu współpracy. Nie obiecujemy gwarantowanych kwot — pokazujemy realny plan i transparentne rozliczenia.",
  },
  {
    q: "Jak szybko mogę zacząć?",
    a: "Zależy nam na szybkim starcie. Wypełnij formularz — odpowiadamy dyskretnie i bez zobowiązań, zwykle w ciągu 24 godzin.",
  },
  {
    q: "Współpracujecie z agencjami i managerami?",
    a: "Tak. Prowadzimy również współpracę B2B dla agencji i managerów oraz szkolenia, jak zarabiać więcej. Napisz do nas z dopiskiem „agencja”.",
  },
];
